import { render, staticRenderFns } from "./UserSessionLogs.vue?vue&type=template&id=079854be&scoped=true"
import script from "./UserSessionLogs.vue?vue&type=script&lang=js"
export * from "./UserSessionLogs.vue?vue&type=script&lang=js"
import style0 from "./UserSessionLogs.vue?vue&type=style&index=0&id=079854be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079854be",
  null
  
)

export default component.exports